export const REGISTER_USER = "register_user"
export const REGISTER_USER_SUCCESSFUL = "register_user_successfull"
export const REGISTER_USER_FAILED = "register_user_failed"

export const VALIDATE_REFERRAL_CODE = "VALIDATE_REFERRAL_CODE"
export const SET_REFERRAL_CODE_VALIDITY_STATUS =
  "SET_REFERRAL_CODE_VALIDITY_STATUS"
